import { flipObject } from '../utils/utils.js';

const supportedPaymentMethods = {
    AK: 'ADYEN_CREDIT_CARD',
    AP: 'APPLE_PAY',
    BANCONTACT_MOBILE: 'BANCONTACT_MOBILE',
    BC: 'BANCONTACT_CARD',
    BM: 'BANCONTACT_MOBILE',
    BK: 'BRAINTREE_CREDIT_CARD',
    BS: 'DIRECT_DEBIT_SEPA',
    CD: 'CASH_ON_DELIVERY',
    DP: 'DOT_PAY',
    ID: 'IDEAL',
    KL: 'KLARNA_PAY_LATER',
    KO: 'KLARNA_PAY_OVER_TIME',
    MB: 'MULTIBANCO',
    OP: 'ONLINE_BANKING_PL',
    PP: 'PAYPAL',
    PT: 'PAYTRAIL',
    R: 'INVOICE',
    TW: 'TWINT',
    TY: 'TRUSTLY',
    VK: 'PREPAYMENT',
};
flipObject(supportedPaymentMethods);
// A map between CardType - CreditCardBrand. Used to get the CreditCardBrand from a given CardType
const creditCardBrandOfCardType = {
    visa: 'visa',
    mastercard: 'master_card',
    'american-express': 'american_express',
    'diners-club': 'diners_club',
    discover: 'other',
    jcb: 'other',
    unionpay: 'other',
    maestro: 'maestro',
    elo: 'other',
    mir: 'other',
    hiper: 'other',
    hipercard: 'other',
    cartebancaire: 'carte_bancaire',
    cartebancontact: 'other',
};
// A map between CreditCardBrand-CardType. Used to get the CardType from a given CreditCardBrand
const cardTypeOfCreditCardBrand = {
    american_express: 'american-express',
    carte_bancaire: 'cartebancaire',
    diners_club: 'diners-club',
    maestro: 'maestro',
    master_card: 'mastercard',
    other: null,
    visa: 'visa',
};
var BraintreeShippingNameIndicator;
(function (BraintreeShippingNameIndicator) {
    BraintreeShippingNameIndicator["ACCOUNT_AND_SHIPPING_NAME_IDENTICAL_01"] = "01";
    BraintreeShippingNameIndicator["ACCOUNT_AND_SHIPPING_NAME_DIFFERENT_02"] = "02";
})(BraintreeShippingNameIndicator || (BraintreeShippingNameIndicator = {}));
var BraintreeAddressMatch;
(function (BraintreeAddressMatch) {
    BraintreeAddressMatch["BILLING_AND_SHIPPING_ADDRESS_IDENTICAL_01"] = "Y";
    BraintreeAddressMatch["BILLING_AND_SHIPPING_ADDRESS_DIFFERENT_02"] = "N";
})(BraintreeAddressMatch || (BraintreeAddressMatch = {}));
var BraintreeAuthenticationIndicator;
(function (BraintreeAuthenticationIndicator) {
    BraintreeAuthenticationIndicator["PAYMENT_01"] = "01";
    BraintreeAuthenticationIndicator["RECURRING_TRANSACTION_02"] = "02";
    BraintreeAuthenticationIndicator["INSTALLMENT_03"] = "03";
    BraintreeAuthenticationIndicator["ADD_CARD_04"] = "04";
    BraintreeAuthenticationIndicator["MAINTAIN_CARD_05"] = "05";
    BraintreeAuthenticationIndicator["CARDHOLDER_VERIFICATION_06"] = "06";
})(BraintreeAuthenticationIndicator || (BraintreeAuthenticationIndicator = {}));
var Sizes;
(function (Sizes) {
    Sizes[Sizes["XXS"] = 320] = "XXS";
    Sizes[Sizes["XS"] = 374] = "XS";
    Sizes[Sizes["SM"] = 544] = "SM";
    Sizes[Sizes["MD"] = 768] = "MD";
    Sizes[Sizes["LG"] = 1024] = "LG";
})(Sizes || (Sizes = {}));

export { BraintreeAddressMatch, BraintreeAuthenticationIndicator, BraintreeShippingNameIndicator, Sizes, cardTypeOfCreditCardBrand, creditCardBrandOfCardType, supportedPaymentMethods };
//# sourceMappingURL=index.js.map
